var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-Divider",class:_vm.classes,style:(_vm.cssVars),attrs:{"data-testid":"t-divider"}})
}
var staticRenderFns = []

export { render, staticRenderFns }